import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const SubTitleTemplate = ({ children, title }) => {
  return (
    <>
      <Paper
      variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          my: 1,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            px: { xs: 1.25, md: 2 },
            py: 1,
            backgroundColor:'#616161',
            color:'#fff'
          }}
        >
          <Typography variant="subtitle2" component="div">
            {title}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            mt: 1,
            px: { xs: 1.25, md: 2 },
            pb: 2,
            minWidth: 0,
          }}
        >
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default SubTitleTemplate;
